module.exports = __webpack_public_path__ + "static/img/food (3).1851131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/restaurant/food (3).jpg
// module id = j51Q
// module chunks = 1